module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-fr2.fe3852e.png";